import styled from "styled-components";

const TrendingSlider = styled.div`
`;
export default TrendingSlider;
